module.exports = __webpack_public_path__ + "img/crc-08.c58cf22f.jpg";